import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './styles.scss';
import Logo from '@mssgme/app/icons/logo_text_white.svg';
import config from 'config';

const Header = ({ button }) => (
    <div className={styles.root}>
        <a href={config.main_url} className={styles.logo}>
            <Logo />
        </a>
        {button && (
            <Link to={button.to} className={styles.link}>
                {button.text}
            </Link>
        )}
    </div>
);

Header.propTypes = {
    button: PropTypes.shape({
        to: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    }),
};

export default Header;
